import React from 'react';


export const BlogReactToNextMigration = (props) => {
    return (
        <>
            <div className='blog-con'>
                <hr />
                <article>

                    <section>
                        <h3>Why Migrate to Next.js?</h3>
                        <br />
                        <p><strong>SEO Benefits: </strong>Next.js supports SSR and SSG, allowing search engines to index pages more effectively.</p>
                        <p><strong>Improved Performance: </strong>By leveraging SSR and code-splitting, Next.js ensures faster initial page loads and improved performance metrics.</p>
                        <p><strong>File-based Routing: </strong>Simplifies routing with a filesystem-based approach, reducing boilerplate code.</p>
                        <p><strong>Built-in API Routes: </strong>Offers backend functionality within the same project, removing the need for an external API server.</p>
                        <p><strong>Automatic Code Splitting: </strong>Ensures only the necessary JavaScript is loaded for a given page.</p>
                    </section>

                    <section>
                        <hr />
                        <h2>Step-by-Step Guide</h2>
                        <br />
                        <h3>Step 1: Install Next.js as dependency</h3>
                        <p>The first thing you need to do is to install next as a dependency:</p>
                        <p>For our example we will use below next version which will follow Page Router of NextJs</p>
                        <pre><code>npm install next@12.0.7</code></pre>

                        <h3>Step 2: Create the next.config.js</h3>
                        <p>Create a next.config.js at the root of your project. This file will hold your Next.js configuration options.</p>
                        <pre><code>{`module.exports = {
    reactStrictMode: true,
    output: 'export',
}                       `}</code></pre>

                        <h3>Step 3: Create the Root Folder Sturcture and Set Entrypoint</h3>
                        <p>In '/src' folder create a folder named 'pages' and put all the page components with Name like 'AboutUs.js to 'about-us.js' inside that folder</p>
                        <p>In '/src' folder create a folder named 'styles' and create file 'global.css' put your index.css and app.css in created css file.</p>
                        <p>create a _app.js file and add your content of App.js in this like,</p>
                        <pre><code>{`import '../styles/globals.css'
import { Footer } from '../components/Footer';
import { Navbar } from '../components/Navbar';

function App({Component, pageProps})
{
    return(
    <>
        <Navbar />
        <Component {...pageProps}/> 
        <Footer/>
    </>
    )
}

export default App
                    `}</code></pre>
                    <p>{`Here <Component {...pageProps}/> is must required. This will handle your components like we use router in react app.`}</p>
                    <h3>Step 4: Metadata Handling</h3>
                    <p>If you are using react-hemlet or any other components in react to handle meta-tags. We don't need any of that in NextJs we can directly put it in out pages like</p>
                    <pre><code>{`import React from 'react';
import { HelmetProvider, Helmet } from 'react-helmet-async';

export default function Aboutus() {
    return (
        <>
            <HelmetProvider>
                <Helmet>
                    <title>Lurantech | About Us | Turning Ideas into Digital Reality</title>
                    <meta name="robots" content="index, follow" />
                    <meta name="description" content="Description" />
                    ...
                </Helmet>
            </HelmetProvider> 
        </>
    );
};`}
                    </code></pre>
                    <p>Uninstall react-helmet and than above code will be replaced by,</p>
                    <pre><code>{`import React from 'react';
import Head from 'next/head'

export default function Aboutus() {
    return (
        <>
            <Head>
                <title>Lurantech | About Us | Turning Ideas into Digital Reality</title>
                <meta name="robots" content="index, follow" />
                <meta name="description" content="Description" />
                ...
            </Head>
        </>
    );
};`}
                    </code></pre>
                    <h3>Step 5: Update Scripts in package.json</h3>
                    <p>Uninstall the react-scripts from module and in package.json replace the scripts by,</p>
                    <pre><code>{`"scripts": {
    "dev": "next dev",
    "build": "next build && next export",
    "start": "next start"
  },`}</code></pre>

                    <h3>Step 6: Migrate the Environment Variables</h3>
                    <p>The main difference is the prefix used to expose environment variables on the client-side. Change all environment variables with the REACT_APP_ prefix to NEXT_PUBLIC_.</p>
                    <pre><code>{`REACT_APP_SERVICE_ID='...'
REACT_APP_TEMPLATE_ID='...'
REACT_APP_PUBLIC_KEY='...'
REACT_APP_SERVER='...'`}
                    </code></pre>
                    <p>This should be define like,</p>
                    <pre><code>{`NEXT_PUBLIC_SERVICE_ID='...'
NEXT_PUBLIC_TEMPLATE_ID='...'
NEXT_PUBLIC_PUBLIC_KEY='...'
NEXT_PUBLIC_SERVER='...'`}
                    </code></pre>

                    <h3>Step 7: Update Static Image Imports</h3>
                    <p>If you were using images like,</p>
                    <pre><code>{`import logo from '/logo.png'
...
// Before
<img src={logo} />`}</code></pre>
                    <p>instead of using images by importing use public images as</p>
                    <pre><code>{`<img src="public/images/logo.png" />`}</code></pre>

                    <h3>Step 8: Clean Up</h3>
                    <p>You can now clean up your codebase from Create React App related artifacts:</p>
                    <p><strong>Delete files:</strong></p>
                    <ul>
                        <li>public/index.html</li>
                        <li>index.js</li>
                        <li>App.js</li>
                        <li>App.css</li>
                        <li>App.text.js</li>
                        <li>index.css</li>
                        <li>reportWebVitals.js</li>
                        <li>setupTests.js</li>
                    </ul>
                    </section>

                    <footer>
                        <h3>Conclusion</h3>
                        <p>Migrating a React app to Next.js unlocks powerful features like SSR, SSG, and improved performance out of the box. While the migration process requires careful planning and execution, the long-term benefits make it worthwhile. With this guide, you now have a clear roadmap to transition your React app to Next.js seamlessly.</p>

                        <br />
                        <p>Happy coding! &#128521;</p>
                    </footer>
                </article>
            </div>
        </>
    );
};
